import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import resiproLogoWhite from "../../assets/Images/resiproLogoWhite.svg";
import { useNavigate } from "react-router-dom";

function HomeTop() {
  const navigate = useNavigate();

  // const [, setAnchorElNav] = React.useState(null);
  // const [anchorElUser, setAnchorElUser] = React.useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  return (
    <AppBar position="static">
      <div className="headerTopBar">
        <div className="container">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img onClick={() => navigate("/")} src={resiproLogoWhite} alt="altimg"/>
            </Typography>
          </Toolbar>
        </div>
      </div>
    </AppBar>
  );
}

export default HomeTop;
